<template>

  <app-layout>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/report.svg" class="h-8 w-8"/>
        <span class="ml-2"> Stand Up - Slack</span>
      </h2>
    </template>


    <a-spin style="z-index: 99999;" :spinning="submitting">

      <div class="h-full flex">
        <div class="flex flex-col w-0 flex-1">
          <main class="flex-1 relative focus:outline-none px-8">

            <div class="mb-4">
              <bread-nav :pages="pages"></bread-nav>
            </div>

            <div v-if="!is_sign_in || !is_installed">
              <div class="flex justify-center">
                <img height="100" width="100" src="/images/logo.png"
                     class="shadow-lg w-45 h-45 mb-5  bg-white rounded-full "/>
              </div>

              <div class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                <svg class="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
                     width="404"
                     height="784" fill="none" viewBox="0 0 404 784" aria-hidden="true">
                  <defs>
                    <pattern id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7" x="0" y="0" width="20" height="20"
                             patternUnits="userSpaceOnUse">
                      <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor"/>
                    </pattern>
                  </defs>
                  <rect width="404" height="784" fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"/>
                </svg>

                <div class="relative">
                  <h2 class="text-center mb-4 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    A better way to create scheduled reports for Slack.
                  </h2>
                </div>

                <div class="py-5 mx-auto max-w-md">
                  <add-to-slack-button></add-to-slack-button>
                  <span
                      class=" text-md text-black font-bold">If your app hasn't been installed, please add AgileBot to your Slack workspace.</span>
                </div>

                <!--                <div class="flex mt-2 justify-center">-->
                <!--          <span-->
                <!--              class=" text-md text-black font-bold">Free for now (For further pricing changes, we will notify you.)</span>-->
                <!--                </div>-->


                <div class="py-5 mx-auto max-w-md">
                  <sign-in-with-slack-button label="Connect Your Slack Account"/>
                  <span
                      class=" text-md text-black font-bold">If the app has already been installed, please connect your Slack account.</span>
                </div>

                <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 font-bold text-lg mt-5">
                  <div class="flex w-full text-red-400 justify-center">
                    <div class="py-1">
                      <svg class="fill-current h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 20 20">
                        <path
                            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
                      </svg>
                    </div>
                    This feature is part of Agile Bot and only supports Slack team.

                  </div>
                </div>

              </div>
            </div>

            <div v-else>

              <div class="bg-green-50 border-l-4 border-green-400 p-4 mb-2" role="alert">
                <p class="text-black font-bold">Tips:</p>
                <p class="text-gray-400 font-bold text-lg"> Use this report for public broadcast, everyone can
                  see responses in public channel.</p>
                <p class="text-gray-400 font-bold text-lg"> For Non-scheduled report, the participants can directly
                  access it via our Slack App through DM channel.</p>
              </div>
              <dialog-modal :show.sync="showModal">
                <template #title>
                  <button
                      @click="showModal=false;"
                      class="absolute top-3 right-3 bg-white hover:bg-blue-100 text-2xl w-8 h-8 rounded-full focus:outline-none font-bold text-gray-500">
                    &cross;
                  </button>
                  <div class="focus:outline-none  text-2xl font-bold font-black">
                    {{ formTitle }}
                  </div>
                  <div class="font-bold text-yellow-500" v-if="isLoadingData">{{ loadingMessage }}</div>
                  <div v-else class="font-bold text-green-500">Channels and Users are loaded successfully.</div>
                </template>

                <template #content>
                  <a-spin style="z-index: 99999;" :spinning="isLoadingData" :tip="loadingMessage">
                    <div class="w-full">
                      <div class="px-5 pt-7 pb-2">

                        <label class="block mb-5">
                          <span class="font-semibold text-sm text-gray-600 pb-1 block">Report Name</span>
                          <input v-model="form.name" type="text"
                                 class="form-input border rounded-lg px-3 py-2 mt-1 text-sm w-full"
                                 placeholder="Enter your report name here" required>
                          <small class="text-gray-500">Enter your custom report name. (must be less than 25
                            characters)</small>
                        </label>


                        <label class="block mb-5">
                          <span
                              class="font-semibold text-sm text-gray-600 pb-1 block">Broadcast Channel ({{
                              options?.length
                            }})</span>
                          <a-select
                              ref="select"
                              v-model:value="selectedChannel"
                              show-search
                              placeholder="Please select a channel"
                              style="width: 100%;"
                              :filter-option="filterOption"
                              :options="options"
                              @change="handleChange"
                              required
                          >
                          </a-select>
                          <small class="text-gray-500">Select a Slack Public channel where your teams answers will
                            be
                            posted. The private channel is not supported.</small>
                        </label>

                        <label class="block mb-5">
                          <span
                              class="font-semibold text-sm text-gray-600 pb-1 block">Participant(s) ({{
                              Object.values(userOptions)?.length
                            }})</span>
                          <a-select
                              v-model:value="selectedUsers"
                              :filter-option="filterOption"
                              mode="multiple"
                              style="width: 100%"
                              placeholder="Please select user(s)"
                              :options="Object.values(userOptions)"
                              @change="handleUserChange"
                          >
                          </a-select>

                          <small class="text-gray-500">Add team members that will participate in this report, answering
                            the questions. </small>
                          <small class="text-gray-500"> For paid account, a new participant will be automatically added to your current
                            team and increase your seat usage.</small>
                        </label>


                        <label class="block mb-5">
                          <span class="font-semibold text-sm text-gray-600 pb-1 block">Question(s)</span>
                          <question-maker limit="5" :questions="this.form.questions"></question-maker>

                          <small class="text-gray-500 mt-6">
                            Note: add question(s) to your report. {last_report_date} is a dynamic variable that displays
                            last report date.
                          </small>
                        </label>

                        <div class="mb-6 flex justify-between">
                          <div class="flex">
                            <label class="font-semibold text-sm text-gray-600 pb-1 block">Scheduled Report</label>
                            <a-tooltip>
                              <template #title>
                                Scheduled reports are triggered automatically per the setting.
                                For Non-scheduled reports, the participants can directly access them via our Slack App
                                through DM channel.
                              </template>
                              <div class="w-5 h-5 text-gray-600">
                                <QuestionMarkCircleIcon class="fill-gray-600"/>
                              </div>

                            </a-tooltip>
                          </div>
                          <a-switch v-model:checked="this.form.is_schedule"/>
                        </div>

                        <div class="input-group mb-3">
                          <div v-if="this.form.is_schedule">
                            <div class="input-group-prepend">
                              <label for="repeat_option"
                                     class="font-semibold text-sm text-gray-600 pb-1 block">Repeat</label>
                            </div>
                            <select class="w-full form-input border rounded-lg px-3 py-2 mt-1 text-sm"
                                    id="repeat_option"
                                    v-model="this.form.scheduler_setting.repeatOption.type">

                              <option v-for="option in repeatOptions" :value="option.value" :key="option.value">
                                {{ option.name }}
                              </option>
                            </select>


                            <div v-if="this.form.scheduler_setting.repeatOption.type === 'every_week'" class="mb-2">
                              <label class="font-semibold text-sm text-gray-600 pb-1 block">Repeat on</label>
                              <div>

                                <div>
                                  <label v-for="(date,key) in weekDayCheckBox" :key="key"
                                         class="py-1 px-2 rounded text-white bg-green-500 mr-2">
                                    <input type="checkbox" :value="date.value"
                                           v-model="this.form.scheduler_setting.repeatOption.everyWeekPicker">
                                    <span class="ml-1">{{ date.name }}</span>
                                  </label>
                                </div>

                              </div>
                            </div>

                            <div class="mb-2">
                              <label class="font-semibold text-sm text-gray-600 pb-1 block">At</label>
                              <div class="input-group mb-3">
                                <time-picker v-model:value="momentDate" style="width: 100%;" use12-hours
                                             format="h:mm A"></time-picker>
                              </div>

                              <label class="font-semibold text-sm text-gray-600 pb-1 block">Timezone</label>
                              <a-select
                                  ref="select"
                                  show-search
                                  v-model:value="timezone"
                                  placeholder="Please select a timezone"
                                  style="width: 100%;"
                                  :options="timezones"
                                  @change="handleTimezoneChange"
                              >
                              </a-select>
                            </div>
                          </div>
                        </div>

                        <div class="flex flex-col">
                          <div class="flex justify-between">
                            <label class="font-semibold text-sm text-gray-600 pb-1 block">Mention Author:</label>
                            <a-switch v-model:checked="this.form.is_mention_enabled"/>
                          </div>
                          <small class="block text-gray-500 mt-1">If its enabled, the submitter gets mentioned
                            for his report in
                            broadcast channel. Disable it if you don't want to get mentioned.</small>
                        </div>
                      </div>
                    </div>
                  </a-spin>
                </template>

                <template #footer>
                  <button
                      @click="showModal = false;"
                      :disabled="submitting"
                      :class="{'text-gray-500': submitting,'text-red-500':!submitting , 'hover:text-red-200': !submitting}"
                      class="font-bold inline-block ml-1 mx-5 px-5 py-4 cursor-pointer font-normal text-lg rounded-lg focus:outline-none  ring-inset">
                    Cancel
                  </button>

                  <button
                      @click="onSubmit"
                      :disabled="submitting"
                      :class="{'text-gray-500': submitting,'text-blue-500 ':!submitting , 'hover:text-blue-300': !submitting}"
                      class="font-bold inline-block ml-1 mx-5 px-5 py-4 cursor-pointer font-normal text-lg rounded-lg focus:outline-none  ring-inset">
                    Submit
                  </button>
                </template>
              </dialog-modal>
              <button @click="showCreateWindow" type="button"
                      class="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">

        <span class="mt-2 block text-lg font-bold font-medium text-gray-900">
      + Create a new report setting
    </span>
              </button>
              <div class="mt-4 grid grid-rows-2 grid-flow-col bg-white p-6 rounded-lg shadow-lg mb-4"
                   v-for="item in items"
                   :key="item.id">
                <div class="row-span-2 inline-block">
                  <span v-if="item.is_schedule"
                        class=" px-2 py-0.5 text-yellow-800 text-xs font-medium bg-yellow-100 rounded-full"> Scheduled Report </span>
                  <span v-else
                        class=" px-2 py-0.5 text-indigo-800 text-xs font-medium bg-indigo-100 rounded-full"> Non-Scheduled Report </span>

                  <span v-if="item.is_free"
                        class="ml-1 px-2 py-0.5 text-indigo-800 text-xs font-medium bg-blue-100 rounded-full"> Free </span>

                  <h2 class="text-2xl font-bold mb-2 text-gray-800">{{ item.name }}</h2>
                  <label v-if="item.user" class="text-sm text-gray-600">Created By: {{ item.user.name }}</label>
                </div>
                <div class="flex justify-end row-span-2">

                  <div class=" mt-2 py-1 px-2">
                    <a-switch v-model:checked="item.is_enabled" @change="enableReport($event,item)"/>
                  </div>

                  <div>
                    <a-tooltip>
                      <template #title>
                        Click it to convert your free template to paid template to unblock participants restrictions.
                      </template>
                      <button v-if="item.is_free" type="button"
                              class="focus:outline-none rounded-full bg-white hover:bg-yellow-100 text-yellow-500 border-2  mt-2 py-1 px-2  border-yellow-500 font-bold rounded"
                              @click="convertEditView($event,item)"
                      >
                        Convert to paid
                      </button>
                    </a-tooltip>


                    <button type="button"
                            class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-blue-500 border-2 ml-2 mt-2 py-1 px-2  border-blue-500 font-bold rounded"
                            @click="showEditWindow($event,item)"
                    >
                      Edit
                    </button>
                    <button type="button"
                            @click="deleteReport($event,item)"
                            class="focus:outline-none rounded-full bg-white hover:bg-red-100 text-red-500 border-2  mt-2 py-1 px-2 ml-2 border-red-500 font-bold rounded">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </main>
        </div>
      </div>


    </a-spin>

  </app-layout>

</template>

<script>
import Button from "@/Jetstream/Button";
import DialogModal from "@/Jetstream/DialogModal";
import {ref, onMounted, watch} from 'vue';
import SchedulerSetting from "@/Components/SchedulerSetting/SchedulerSetting";
import QuestionMaker from "@/Components/QuestionMaker/QuestionMaker";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import AppLayout from "@/Layouts/AppLayout";
import {TimePicker} from 'ant-design-vue';
import moment from 'moment';
import {message} from "ant-design-vue";
import AddToSlackButton from "@/Components/SocialButton/AddToSlackButton";
import SignInWithSlackButton from "@/Components/SocialButton/SignInWithSlackButton";
import ResponsePage from "@/Pages/StandUp/Response/ResponsePage";
import BreadNav from "@/Components/BreadNav/BreadNav";
import {
  QuestionMarkCircleIcon,
} from "@heroicons/vue/outline";

const pages = [
  {name: 'Report', href: '#', current: false},
  {name: 'Public Reports', href: '#', current: true},
]
export default {
  props: [
    "slack_user", 'is_installed', 'is_sign_in', 'is_paid'
  ],
  components: {
    BreadNav,
    ResponsePage,
    SignInWithSlackButton,
    AddToSlackButton,
    AppLayout,
    SecondaryButton,
    QuestionMaker,
    SchedulerSetting,
    DialogModal,
    Button,
    moment,
    TimePicker,
    message,
    QuestionMarkCircleIcon
  },
  methods: {
    enableReport(evt, item) {
      let app = this;
      app.submitting = true;
      window.axios.patch('/web/apps/agile-bot/report-settings/' + item.id + '/activate', {is_enabled: item.is_enabled})
          .then(function (response) {

            if (response.data.success === false) {
              app.submitting = false;
              message.error(response.data.message)
              item.is_enabled = false;
            } else {
              if (item.is_enabled) {
                app.submitting = false;
                message.success('You have activated a report')
              } else {
                app.submitting = false;
                message.success('You have deactivated a report.')
              }
            }
          })
          .catch(function (error) {
            app.submitting = false;
            message.error('System Error, Please contact us.')
          });
    },
    onEdit() {
      let app = this;
      app.submitting = true;
      this.form.scheduler_setting.repeatAt.timezone = this.timezone;
      this.form.scheduler_setting.repeatAt.time = this.momentDate.format('H:mm:ss');

      const slackUsers = this.selectedUsers.map((id) => {
        return this.userOptions[id];
      });
      window.axios.put('/web/apps/agile-bot/report-settings/' + this.form.id, {
        ...this.form,
        channel_id: this.selectedChannel,
        selected_users: this.selectedUsers,
        selected_slack_users: slackUsers
      })
          .then(function (response) {
            if (response.data.success === false) {
              app.submitting = false;
              message.error(response.data.message)
            } else {
              app.submitting = false;
              app.showModal = false;
              app.getItems();
              message.success('Nice, you have successfully updated a report.')
            }
          })
          .catch(function (error) {
            app.submitting = false;
            message.error('System Error, Please contact us.')
          });
    },
    onCreate() {

      let app = this;
      app.submitting = true;
      this.form.scheduler_setting.repeatAt.timezone = this.timezone;
      this.form.scheduler_setting.repeatAt.time = this.momentDate.format('H:mm:ss');
      const slackUsers = this.selectedUsers.map((id) => {
        return this.userOptions[id];
      });

      window.axios.post(route('standup.submitSetting'), {
        ...this.form,
        channel_id: this.selectedChannel,
        selected_users: this.selectedUsers,
        selected_slack_users: slackUsers
      })
          .then(function (response) {

            if (response.data.success === false) {
              app.submitting = false;
              message.error(response.data.message)
            } else {
              app.submitting = false;
              app.showModal = false;
              app.getItems();
              message.success('Nice, you have successfully created a report.')
            }
          })
          .catch(function (error) {
            app.submitting = false;
            message.error('System Error, Please contact us.')
          });
    },
    onSubmit(evt) {
      evt.preventDefault();
      switch (this.settingType) {
        case 'create':
          this.onCreate();
          break;
        case 'edit':
          this.onEdit();
          break;
        default:
          break;
      }
    },
    convertEditView(evt, item) {
      evt.preventDefault();
      this.settingType = 'edit';
      this.formTitle = 'Convert to paid report: ' + item.name;
      this.form = {
        id: item.id,
        name: item.name,
        questions: item.questions,
        is_mention_enabled: item.is_mention_enabled,
        scheduler_setting: item.scheduler_setting,
        is_schedule: item.is_schedule,
        is_convert: true
      };
      this.selectedUsers = item.selected_users;
      this.selectedChannel = item.channel_id;
      this.timezone = item.scheduler_setting.repeatAt.timezone;
      this.showModal = true;
      this.changeMomentDate(moment(this.form.scheduler_setting.repeatAt.time, 'h:mm:ss A'));
    },
    showEditWindow(evt, item) {
      evt.preventDefault();
      this.settingType = 'edit';
      this.formTitle = 'Edit a report: ' + item.name;
      this.form = {
        id: item.id,
        name: item.name,
        questions: item.questions,
        is_mention_enabled: item.is_mention_enabled,
        scheduler_setting: item.scheduler_setting,
        is_schedule: item.is_schedule
      };
      this.selectedUsers = item.selected_users;
      this.selectedChannel = item.channel_id;
      this.timezone = item.scheduler_setting.repeatAt.timezone;
      this.showModal = true;
      this.changeMomentDate(moment(this.form.scheduler_setting.repeatAt.time, 'h:mm:ss A'));
    },
    showCreateWindow() {
      this.settingType = 'create';
      this.formTitle = 'Create a report';
      this.form = {...this.defaultForm};
      this.selectedUsers = [];
      this.selectedChannel = null;
      this.timezone = null;
      this.changeMomentDate(moment(this.form.scheduler_setting.repeatAt.time, 'h:mm:ss A'));

      this.showModal = true;
    },
    async getItems() {
      let app = this;
      app.submitting = true;
      await window.axios.get(route('standup.getReportSettings'))
          .then(function (response) {
            app.submitting = false;
            app.items = response.data;
          })
          .catch(function (error) {
            app.submitting = false;
            message.error('Your app is unauthorised or uninstalled. Please reinstall it.', 10)
          });
    },
    deleteReport(evt, item) {
      evt.preventDefault();
      if (confirm('Are you sure that you want to delete it?')) {
        let app = this;
        app.submitting = true;
        window.axios.delete('/web/apps/agile-bot/report-settings/' + item.id)
            .then(function (response) {
              app.submitting = false;
              app.getItems();
              message.success('You have successfully deleted a report.')
            })
            .catch(function (error) {
              app.submitting = false;
              message.success('System error, please contact us.', 10)
            });
      }
    }
  },
  mounted() {
    this.getItems();
  },
  created() {
    this.form = {...this.defaultForm};
  },
  setup() {
    const momentDate = ref(moment('10:00', 'HH:mm:ss'));

    watch(momentDate, () => {
      console.log(momentDate.value);
    });

    const timezones = ref([]);
    const timezone = ref(null);

    function changeMomentDate(date) {
      momentDate.value = date;
    }

    function getTimezoneList() {
      window.axios.get(route('standup.getTimezones'))
          .then(function (response) {
            timezones.value = response.data.timezones;
          })
          .catch(function (error) {

          });
    }

    const handleTimezoneChange = (value) => {
      timezone.value = value;
    };

    onMounted(() => {
      getTimezoneList();
    });


    const options = ref([]);
    const userOptions = ref([]);
    const selectedChannel = ref(undefined);
    const selectedUsers = ref([]);

    const isLoadingData = ref(false);
    const loadingMessage = ref('Your channels and users are loading, please wait a few seconds...')

    function getSettingOptions() {
      isLoadingData.value = true;
      window.axios.get(route('standup.getSettings'))
          .then(response => {
            isLoadingData.value = false;
            options.value = response.data.settings.channel_options;
            userOptions.value = response.data.settings.users_options;
            console.log(response);
          })
          .catch(error => {
            isLoadingData.value = false;
            loadingMessage.value = 'Sorry we cannot load your data right now. Please contact support@agilesuite.io.'
          });
    }

    onMounted(() => {
      getSettingOptions();
    });

    const handleChange = (value) => {
      selectedChannel.value = value;
    };

    const handleUserChange = (value) => {
      selectedUsers.value = value;
    }
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    return {
      filterOption,
      pages,
      changeMomentDate,
      momentDate,
      handleChange,
      handleUserChange,
      selectedUsers,
      options,
      isLoadingData,
      loadingMessage,
      userOptions,
      timezone,
      timezones,
      handleTimezoneChange,
      selectedChannel,
    }
  },
  data() {
    return {
      showSideBar: true,
      currentIndex: 1,
      submitting: false,
      weekDayCheckBox: [
        {
          name: 'Mon',
          value: '1',
          full_name: 'Monday'
        },
        {
          name: 'Tue',
          value: '2',
          full_name: 'Tuesday'
        },
        {
          name: 'Wed',
          value: '3',
          full_name: 'Wednesday'
        },
        {
          name: 'Thu',
          value: '4',
          full_name: 'Thursday'
        },
        {
          name: 'Fri',
          value: '5',
          full_name: 'Friday'
        }
        , {
          name: 'Sat',
          value: '6',
          full_name: 'Saturday'
        },
        {
          name: 'Sun',
          value: '7',
          full_name: 'Sunday'
        },
      ],
      type: 'create',
      formTitle: '',
      startIndex: null,
      showModal: false,
      settingType: 'create',
      items: [],
      form: null,
      repeatOptions: [
        {
          name: 'every week',
          value: 'every_week'
        },
        {
          name: 'every day',
          value: 'every_day'
        }
      ],
      selectedItem: null,
      defaultForm: {
        name: null,
        is_mention_enabled: true,
        is_schedule: true,
        questions: [
          {
            sort: 3,
            subject: 'Anything blocking your progress?'
          },
          {
            sort: 1,
            subject: 'What did you do since {last_report_date}?'
          },
          {
            sort: 2,
            subject: 'What will you do today?'
          },
        ],
        scheduler_setting: {
          repeatOption: {
            type: 'every_week',
            everyWeekPicker: ['1', '2', '3', '4', '5']
          },
          repeatAt: {
            time: '10:00:00',
            timezone: null
          },
        },
      },
    }
  }
}
</script>
